import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Sidebar } from "primereact/sidebar";
import { Dialog } from "primereact/dialog";
import moment from "moment";

import Button from "../../helpers/Button";
import Table from "../../helpers/Table"

import Loading from "../../common/Loading";
import ButtonGroup from "../../common/ButtonGroup";

import "./index.css"

import Menu from "../../helpers/Menu";
import { InputSwitchField } from "../../helpers";
import AddChequeBook from "./Components/AddChequeBook";
import ViewChequeBook from "./Components/ViewChequeBook";
import Search from "./Components/Search";

import { fetchChequeBooks } from "../../services/redux/reducers/commonThunk";
import { updateChequeStatus } from "../../services/api/cheques";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { getCheques } from "../../services/api/cheques";

import { sortArrayOfObjectsInAlphabeticalOrder, numberConversion, getCompanyShortName, isMobile } from "../../utils";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { DATE_FORMAT } from "../../constants";


const ChequeBook = () => {
    const [isSearchVisible, setIsSearchVisible] = useState(true)
    const [visibleAddChequeBook, setVisibleAddChequeBook] = useState(false)
    const [visibleViewChequeBook, setVisibleViewChequeBook] = useState(false)
    const [cheques, setCheques] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [tableLoading, setTableLoading] = useState(false)
    const [searchConfig, setSearchConfig] = useState([]);

    const [paginationParams, setPaginatonParams] = useState({
        page: 0,
        rows: 10,
        first: 0,
        last: 10
    })

    const actionMenu = useRef(null)

    const chequeBooks = useSelector(state => state.common.chequeBooks)
    const searchParams = useSelector(state => state.common.chequeBooksSearchParams)

    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const dispatch = useDispatch()

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchChequeBooks())
        getChequeBooksSeries()
    }, [])

    const handleSearchConfigUpdate = (configFromSearch) => {
        setSearchConfig(configFromSearch);
    };

    const actionMenuItems = [
        {
            label: 'Add Cheque Book' ,
            icon: '',
            command: () => {
                setVisibleAddChequeBook(true)
            },
            permissions: [112]
        },
        {
            label: 'View Cheque Book' ,
            icon: '',
            command: () => {
                setVisibleViewChequeBook(true)
            },
        },
    ];

    const searchCheques = async () => {
        console.log("searc", searchParams)
        if(searchParams.chequeSeries !== "all"){
            setIsLoading(true)
            const response = await getCheques({...paginationParams, ...searchParams, include: [{ model: "vendorPayment", attributes: ["amount"] }]})
            const chequesArray = [] 
            chequeBooks.map((eachChequeBook) => {
                if(eachChequeBook.statusId === 1 && eachChequeBook.chequeBookId === searchParams.chequeSeries){
                    let chequeNo = eachChequeBook.chequeSeriesFrom
                    const chequeBookEndNo = eachChequeBook.chequeSeriesTo
                    const allRealatedCheques = response.data.filter((eachCheque) => eachCheque.chequeBookId === eachChequeBook.chequeBookId)

                    while (chequeNo <= chequeBookEndNo) {
                        const relatedCheque = allRealatedCheques?.find((eachCheque) => eachCheque.chequeNo == chequeNo)

                        const chequeObj = {
                            chequeId: relatedCheque?.chequeId ? relatedCheque.chequeId : null,
                            chequeNo: chequeNo,
                            companyBankAccounts: {
                                bankName: eachChequeBook.companyBankAccounts.bankName,
                                accNo: eachChequeBook.companyBankAccounts.accNo,
                            },
                            chequeDate: relatedCheque?.chequeDate ? relatedCheque.chequeDate : "-",
                            chequeRealisedDate: relatedCheque?.chequeRealisedDate ? relatedCheque.chequeRealisedDate : "-",
                            statusId: relatedCheque?.statusId ? relatedCheque.statusId : 1
                        }

                        chequesArray.push({...chequeObj});
                        chequeNo++;
                    }
                    return 1
                } 
            })
            
            setCheques([...chequesArray])
            setIsLoading(false)
        }else{
            generateCheques()
        }
    }

    const getChequeBooksSeries = () => {
        const chequeBooksSeriesTemplate = []
        chequeBooks.filter((eachChequeBook) => {
            if(eachChequeBook.statusId === 1){
                const optionObj = {
                    label: `${eachChequeBook.companyBankAccounts.bankName} | ${eachChequeBook.chequeSeriesFrom} To ${eachChequeBook.chequeSeriesTo}`,
                    value: eachChequeBook.chequeBookId
                }
                chequeBooksSeriesTemplate.push(optionObj)
            }
        })

        const sortedChequeBooksSeries = sortArrayOfObjectsInAlphabeticalOrder(chequeBooksSeriesTemplate, "label")
        setSearchConfig([...searchConfig, 
            {
                srNO: searchConfig.length + 1,
                static: true,
                type: "SELECT",
                name: "chequeSeries",
                label: "Cheque Series",
                options: [ { label: 'No Filters', value: 'all' }, ...sortedChequeBooksSeries ]
        }])
        setIsLoading(false)
    }
    
    const generateCheques = async () => {
        setIsLoading(true)
        const allCheques = await getCheques({paginator: false, include: [{ model: "vendorPayment", attributes: ["amount"] }]})
        const chequesArray = [] 
        chequeBooks.map((eachChequeBook) => {
            if(eachChequeBook.statusId === 1){
                let chequeNo = eachChequeBook.chequeSeriesFrom
                const chequeBookEndNo = eachChequeBook.chequeSeriesTo
                const allRealatedCheques = allCheques.data.filter((eachCheque) => eachCheque.chequeBookId === eachChequeBook.chequeBookId)

                while (chequeNo <= chequeBookEndNo) {
                    const relatedCheque = allRealatedCheques?.find((eachCheque) => eachCheque.chequeNo == chequeNo)

                    const chequeObj = {
                        chequeId: relatedCheque?.chequeId ? relatedCheque.chequeId : null,
                        chequeNo: chequeNo,
                        companyBankAccounts: {
                            bankName: eachChequeBook.companyBankAccounts.bankName,
                            accNo: eachChequeBook.companyBankAccounts.accNo,
                        },
                        chequeDate: relatedCheque?.chequeDate ? relatedCheque.chequeDate : "-",
                        chequeRealisedDate: relatedCheque?.chequeRealisedDate ? relatedCheque.chequeRealisedDate : "-",
                        statusId: relatedCheque?.statusId ? relatedCheque.statusId : 1
                    }
                    chequesArray.push({...chequeObj});
                    chequeNo++;
                }
                return 1
            } 
        })
        
        setCheques([...chequesArray])
        setIsLoading(false)
    }

    const handleUpdateChequeStatus = async (row) => {
        
        if(row.statusId === 1 && row.chequeRealisedDate === "-" ){
            if(window.confirm("Do you want to deactivate cheque")){
                setIsLoading(true)

                const updateChequeObj = { ...row, statusId: 2 }

                const deleteChequeResponse = await updateChequeStatus(row.chequeNo, updateChequeObj)
                setIsLoading(false)
                if(deleteChequeResponse.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'Cheque', detail: deleteChequeResponse.data.error, life: 3000}))
                }else{
                    const updatedChequesList = cheques.map((eachCheque) => {
                        if(eachCheque.chequeNo === row.chequeNo){
                            return {
                                ...eachCheque,
                                statusId: 2
                            }
                        }else {
                            return eachCheque
                        }
                    })
                    setCheques(updatedChequesList)
                    return dispatch(raiseToast({severity:'success', summary: 'Cheque Book', detail: "Deleted successfully", life: 3000}))
                }
            }
        }
        if(row.statusId === 2 && row.chequeRealisedDate === "-"){
            if(window.confirm("Do you want to activate cheque")){
                setIsLoading(true)

                const updateChequeObj = { ...row, statusId : 1}

                const deleteChequeResponse = await updateChequeStatus(row.chequeNo, updateChequeObj)
                setIsLoading(false)
                if(deleteChequeResponse.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'Cheque', detail: deleteChequeResponse.data.error, life: 3000}))
                }else{
                    const updatedChequesList = cheques.map((eachCheque) => {
                        if(eachCheque.chequeNo === row.chequeNo){
                            return {
                                ...eachCheque,
                                statusId: 1
                            }
                        }else {
                            return eachCheque
                        }
                    })
                    setCheques(updatedChequesList)
                    return dispatch(raiseToast({severity:'success', summary: 'Cheque Book', detail: "Deleted successfully", life: 3000}))
                }
            }
        }
    }

    const getStatus = (row) => {
        return (
            <InputSwitchField onChange={() => handleUpdateChequeStatus(row)} checked={row.statusId === 1 ? true : false} permissions={[111]}/>
        )
    }

    const getBankName = (row) => {
        return (
            <div className="text-center">
                <div>{row.companyBankAccounts?.bankName}</div>
                <div className="account-no">{row.companyBankAccounts?.accNo}</div>
            </div>
        )
    }

    const getChequeNumber = (row) => {
        return (
            <div className="text-center">
                <div>{row.chequeNo}</div>
                <div>{row.chequeDate !== "-" ? row.chequeDate : ""}</div>
            </div>
        )
    }

    const getPaymentDate = () => {
        return "-"
    }

    const getRealisedDate = (row) => {
        return(
            moment(row.chequeRealisedDate).format(DATE_FORMAT)
        )
    }

    const getAmount = (row) => {
        return(
            numberConversion(row.amount, numberLocale)
        )
    }

    const getSellerCompany = (row) =>{
        return(
            getCompanyShortName(row.sellerCompany)
        )
    }

    const handlePageChange = async (e) => {
        setTableLoading(true)

        setPaginatonParams({
            page: e.page,
            rows: e.rows,
            first: e.first,
            last: e.last
        })
        
        setTimeout(() =>{
            setTableLoading(false)
        }, 100)
    }

    

    const tableColumns = [
        {
            header: 'Bank Name', field: '', style: { textAlign: "center" }, body: getBankName
        },
        {
            header: 'Cheque Number', field: '', style: { textAlign: "center",  minWidth: "120px" }, body: getChequeNumber
        },
        {
            header: 'Seller Company', field: 'sellerCompany', style: { textAlign: "center", minWidth: "180px" }, body: getSellerCompany
        },
        {
            header: 'Seller Name', field: 'sellerName', style: { textAlign: "center", minWidth: "130px" }
        },
        {
            header: 'Amount', field: 'amount', style: { textAlign: "center" },  body: getAmount
        },
        {
            header: 'Payment Date', field: 'PaymentDate',  style: { textAlign: "center",  minWidth: "120px" }, body: getPaymentDate
        },
        {
            header: 'Realised Date', field: 'realisedDate', style: { textAlign: "center",  minWidth: "120px" }, body: getRealisedDate
        },
        {
            header: 'Status', field: '', style: { textAlign: "center" }, body: getStatus
        }
    ]

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => setIsSearchVisible(!isSearchVisible),
            // className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return (
        <div className="cheque-book-layout flex flex-column">
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">CHEQUE BOOK</h4>
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <div className='chque-book-action-Body'>
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    </div>
                    <Button icon="pi pi-filter" className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Filter" onClick={() => { setIsSearchVisible(!isSearchVisible) }} /> */}
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <Loading visible={isLoading} />
            <div className='flex flex-row'>
                <div className="cheque-book-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table
                                lazy
                                paginator
                                page={paginationParams.page} 
                                onPageChange={(e)=> handlePageChange(e)} 
                                totalRecords={cheques.length} 
                                tableColumns={tableColumns} 
                                data={cheques.slice(paginationParams.first, paginationParams.last)} 
                                rows={paginationParams.rows} 
                                scrollable={"true"} 
                                scrollHeight="550px"
                                loading={tableLoading}   
                            />
                        </div>
                    </div>
                </div>
                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Search onSearchConfigUpdate={handleSearchConfigUpdate} searchCheques={searchCheques}/>
                    </div>
                }

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => setIsSearchVisible(false)}>
                            <Search pettycashSearchConfig={searchConfig} searchCheques={searchCheques}/>
                        </Sidebar>
                    </div>
                }
            </div>
            <Dialog header="Add Cheque Book" visible={visibleAddChequeBook} style={{ width: '50vw', height: '50vh' }} onHide={() => setVisibleAddChequeBook(false)}>
                <AddChequeBook setVisibleAddChequeBook={() => setVisibleAddChequeBook(false)}/>
            </Dialog>

            <Dialog header="Cheque Books" className="view-cheque-book-dialog" contentStyle={{ backgroundColor: "#f8f9fa" }} visible={visibleViewChequeBook} style={{ width: '78vw', backgroundColor: "#eeeff0", minHeight:'50vh', height:'80vh' }} onHide={() => setVisibleViewChequeBook(false)}>
                <ViewChequeBook setVisibleViewChequeBook={() => setVisibleViewChequeBook(false)}/>
            </Dialog>
        </div>
    )
}

export default ChequeBook;